import { useCreate } from '@refinedev/core';
import { User, UserStatus, UserRole } from '../types';

type CreateUserPayload = {
  emailAddress?: string | null;
  firstName: string;
  lastName: string;
  userRole: UserRole;
  userStatus: UserStatus;
};

export function useCreateUser({ companyId }: { companyId?: string } = {}) {
  const { mutateAsync, error, isLoading, reset } = useCreate<User>();

  const createUser = async (values: CreateUserPayload) => {
    return mutateAsync({
      resource: companyId ? `admin/companies/${companyId}/users` : 'users',
      values,
    });
  };

  return {
    createUser,
    error,
    isLoading,
    reset,
  };
}
